
















import Vue from 'vue'
import RadioButton from '@/components/globals/basics/RadioButton.vue'
import { ProgramLevel } from '@/core/Programs'

export default Vue.extend({
  components: {
    RadioButton,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    hideClear: {
      type: Boolean as () => boolean,
      default: false,
    },
  },
  data: () => ({
    ProgramLevel,
  }),
  methods: {
    onChange() {
      this.$emit('onChange', !this.value)
    },
  },
})
